module.exports = __webpack_public_path__ + "img/PCDIQIUCOPY.8fa0f6b1.png";